/**
* Gereral API Requests
*/
export default function () {
  const { confGlobal, confServices } = useConfig()
  const { requestHeaders, requestsCachingOptions } = useApi()
  const { $i18n: i18n } = useNuxtApp()
  const { currentRoute } = useRouter()
  const toast = useToast()

  /**
  * Get Entry Endpoint
  */
  const getEntry = () => {
    try {
      const data = useAsyncData('entry_endpoint', async () => {
        /**
        * Request
        */
        return await $fetch(`${confGlobal.apiUrl}/healthcheck`, {
          method: 'GET',
          headers: requestHeaders()
        }).then(async (res) => {
          const entryDataRes = await res

          return entryDataRes
        }).catch((err) => { 
          console.log(err)

          return false
        })
      })

      return data
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Get Countries
  */
  const countries = useState('countries', () => false)
  const getCountries = () => {
    try {
      return $fetch(`${confGlobal.apiUrl}/countries`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        countries.value = await res
        return countries.value.data.countries
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }
  /**
  * Get Countries
  */
  const country = useState('countries', () => false)
  const getCountry = () => {
    try {
      return $fetch(`${confGlobal.apiUrl}/country`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        country.value = await res
        return countries.value.data.countries
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }
  const getCountriesForSelect = async (getAll = true) => {
    if (getAll) {
      if ((countries.value && !countries.value.data.countries) || !countries.value) {
        await getCountries()
      }
    } else {
      await getCountry()
    }

    return Object.keys(countries.value.data.countries).map((n) => {
      return {
        name: countries.value.data.countries[n].name,
        value: countries.value.data.countries[n].country_id
      }
    })
  }

  /**
  * Get Zones
  */
  const zones = useState('zones', () => false)
  const getZones = (countryId) => {
    try {
      if (!countryId) {
        return false
      }

      return $fetch(`${confGlobal.apiUrl}/countries/${countryId}/zones`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        zones.value = await res

        return zones.value
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }
  const getZonesForSelect = async (countryId) => {
    if (!countryId || countryId === '0') {
      return []
    }

    const zonesNew = await getZones(countryId)

    return Object.keys(zonesNew.data.zones).map((n) => {
      return {
        name: zonesNew.data.zones[n].name,
        value: zonesNew.data.zones[n].zone_id
      }
    })
  }

  /**
  * Upload Image
  */
  const uploadImage = async (formData) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/images/upload', {
        method: 'POST',
        headers: {
          'store-id': confGlobal.site.toUpperCase()
        },
        body: formData
      }).then((res) => {
        if (res.data) {
          if (!res.data.main.success) {
            toast.add({
              severity: 'success',
              detail: res.data.main.success,
              life: 5000
            })
            return false
          }
        } else {
          toast.add({
            severity: 'error',
            detail: i18n?.t('serverError'),
            life: 5000
          })
          return false
        }
        return res
      }).catch((err) => {
        if (err.data && err?.data?.error && err?.data?.error?.description) {
          const errors = []

          if (typeof err?.data?.error?.description === 'object') {
            for (const i in err?.data?.error?.description) {
              if (typeof err?.data?.error?.description[i] === 'object') {
                for (const m in err?.data?.error?.description[i]) {
                  errors.push(err?.data?.error?.description[i][m])
                }
              } else {
                errors.push(err?.data?.error?.description[i])
              }
            }
          } else {
            errors.push(err?.data?.error?.description)
          }

          console.log(err)

          return { status: 'error', description: errors }
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Upload File
  */
  const uploadFile = async (formData) => {
    try {
      // Uploading
      return $fetch(confGlobal.apiUrl + '/files', {
        method: 'POST',
        headers: {
          'store-id': confGlobal.site.toUpperCase()
        },
        body: formData
      }).then((res) => {
        if (res.data) {
          if (!res.data.main.success) {
            toast.add({
              severity: 'success',
              detail: res.data.main.success,
              life: 5000
            })
            return false
          }
        } else {
          toast.add({
            severity: 'error',
            detail: i18n?.t('serverError'),
            life: 5000
          })
          return false
        }
        return res
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Delete File
  */
  const deleteFile = async (data) => {
    try {
      const bucket = confGlobal.serverType === 'PROD' ? confServices.s3BucketName : confGlobal.testS3BucketName

      return await $fetch(confGlobal.apiUrl + '/files/' + bucket + '/' + data.fileName, {
        method: 'DELETE',
        headers: {
          'store-id': confGlobal.site.toUpperCase()
        }
      }).then((res) => {
        return res
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * GET Vimeo info
  */
  const getVimeoInfo = async (paramsData) => {
    try {
      let paramsString = new URLSearchParams(paramsData).toString()
      if (paramsString) {
        paramsString = '?' + paramsString
      }

      return await $fetch(confGlobal.apiUrl + `/video/get-info${paramsString}`, {
        method: 'GET',
        headers: requestHeaders()
      }).then((res) => {
        return res
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Upload Vimeo
  */
  const uploadVimeo = async(formData) => {
    try {
      // Uploading
      return $fetch(confGlobal.apiUrl + '/video/upload', {
        method: 'POST',
        headers: requestHeaders({
          'content-type': false
        }),
        body: formData
      }).then((res) => {
        if (!res.data.video_info) {
          toast.add({
            severity: 'error',
            detail: i18n?.t('uploadingFailed'),
            life: 5000
          })
        }

        return res
      }).catch((err) => {
        if (err.data && err?.data?.error && err?.data?.error?.description) {
          const errors = []

          if (typeof err?.data?.error?.description === 'object') {
            for (const i in err?.data?.error?.description) {
              if (typeof err?.data?.error?.description[i] === 'object') {
                for (const m in err?.data?.error?.description[i]) {
                  errors.push(err?.data?.error?.description[i][m])
                }
              } else {
                errors.push(err?.data?.error?.description[i])
              }
            }
          } else { 
            errors.push(err?.data?.error?.description)
          }
          toast.add({
            severity: 'error',
            detail: errors.toString(),
            life: 5000
          })
          
          return { status: 'error', description: errors }
        }

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Delete File
  */
  const deleteVimeo = async (paramsData) => {
    try {
      let paramsString = new URLSearchParams(paramsData).toString()
      if (paramsString) {
        paramsString = '?' + paramsString
      }

      return await $fetch(confGlobal.apiUrl + `/video/remove${paramsString}`, {
        method: 'DELETE',
        headers: requestHeaders()
      }).then((res) => {
        return res
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Get Video Data
  */
  const getVideo = async (videoId) => {
    try {
      return $fetch(confGlobal.apiUrl + `/video-library/${videoId}`, {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        return res
      }).catch((err) => {
        console.log(err)

        return false
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Send Feedback
  */
  const sendFeedback = async (params = {}) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/forms/feedback/' + params.formType, {
        method: 'POST',
        headers: requestHeaders(),
        body: params
      }).then((res) => {
        return res
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Unsubscribe
  */
  const unsubscribe = async (params = {}) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/unsubscribe/', {
        method: 'POST',
        headers: requestHeaders(),
        body: params
      }).then((res) => {
        return res
      }).catch((err) => {
        console.log(err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Get Reviews
  */
  const getReviews = (params) => {
    try {
      return useAsyncData(`shopperApprovedReviews_${params.limit}`, async () => {
        /**
        * Request
        */
        return await $fetch(`${confGlobal.apiUrl}/shopper-approved/reviews?limit=${params.limit ? params.limit : '7'}`, {
          method: 'GET',
          headers: requestHeaders()
        }).then(async (res) => {
          return await res.data
        })
      },
      {
        transform (input) {
          return {
            ...input,
            enableCache: !currentRoute.value.fullPath.includes('?') && input,
            fetchedAt: new Date()
          }
        },
        getCachedData (key) {
          return requestsCachingOptions(key)
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Return Object
  */
  return {
    getEntry,
    
    countries,
    getCountries,
    country,
    getCountry,
    getCountriesForSelect,
    zones,
    getZones,
    getZonesForSelect,

    uploadImage,
    uploadFile,
    deleteFile,

    getVimeoInfo,
    uploadVimeo,
    deleteVimeo,

    getVideo,

    sendFeedback,
    unsubscribe,

    getReviews
  }
}
